import { render, staticRenderFns } from "./Ico.vue?vue&type=template&id=56446c36&scoped=true&"
import script from "./Ico.vue?vue&type=script&lang=js&"
export * from "./Ico.vue?vue&type=script&lang=js&"
import style0 from "./Ico.vue?vue&type=style&index=0&id=56446c36&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56446c36",
  null
  
)

export default component.exports